// register.jsx

import { useState } from "react";
import axios from "axios";

const Register = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "user", // ✨ Default role
    avatar: "https://api.dicebear.com/6.x/initials/svg?seed=User", // ✨ Default avatar
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // ✨ Basic validation
    if (!form.name || !form.email || !form.password) {
      return setError("All fields are required!");
    }

    try {
      await axios.post("http://localhost:5000/api/auth/register", form);
      setSuccess("🎉 Registered successfully! Please log in.");
      setForm({ name: "", email: "", password: "", role: "user", avatar: "" });
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 border rounded shadow">
      <h2 className="text-2xl font-bold mb-4 text-center">🚀 Register</h2>

      {error && <div className="bg-red-100 text-red-700 p-2 mb-2 rounded">{error}</div>}
      {success && <div className="bg-green-100 text-green-700 p-2 mb-2 rounded">{success}</div>}

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="text"
          placeholder="Full Name"
          className="p-2 border rounded"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <input
          type="email"
          placeholder="Email"
          className="p-2 border rounded"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <input
          type="password"
          placeholder="Password"
          className="p-2 border rounded"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />

        {/* ✨ Bonus: Choose role during registration */}
        <select
          value={form.role}
          onChange={(e) => setForm({ ...form, role: e.target.value })}
          className="p-2 border rounded"
        >
          <option value="user">User</option>
          <option value="moderator">Moderator</option>
        </select>

        <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded">
          Register
        </button>
      </form>
    </div>
  );
};

export default Register;
